import React from 'react';

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import {getCustomer} from "../router"
import OrderSummary from '../components/order-summary';
import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/MyAccount.aspx?resize=true`;

export default function IframeAccount() {

    const { data: customer, isPending: customerPending } = getCustomer();
    return (
        <div className={`booking-pathway__container booking-pathway__iframe-account ${customer ? 'loggedin' : ''}`}>
            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Account</h1>
                <IFrame url={iframeURL} title="Account" hasLoader="true" />
            </div>
        </div>
    );
}